<template>
  <div>
    <validation-observer ref="form">
      <form novalidate @submit.prevent="saveWoundCourse">
        <mdb-modal side position="right" fullHeight direction="right" :show="modal" @close="close">
            <mdb-modal-header>
                <mdb-modal-title class="h4">
                  Wundverlauf erstellen
                  <span class="h6 d-flex mb-0">({{ woundDetails.ort }})</span>
                </mdb-modal-title>
            </mdb-modal-header>
              <mdb-modal-body class="example-card scrollbar-blue thin">
                <validation-provider
                  name="Datum"
                  rules="required"
                  v-slot="{ errors, valid, validated }"
                  slim
                >
                  <mdb-date-picker
                    v-model="erhebung"
                    disabledFuture
                    label="Datum"
                    name="Datum"
                    :option="optionDatePicker"
                    :customValidation="validated"
                    :isValid="valid"
                    :invalidFeedback="errors[0]"
                    validFeedback="sieht gut aus"
                    outline
                    @getValue="getPickersValue"
                  />
                </validation-provider>
                <validation-provider
                  name="Größe Durchmesser in cm"
                  rules="max:10"
                  v-slot="{ errors, valid, validated }"
                  slim
                >
                  <mdb-input
                    v-model="form.Durchmesser"
                    type="text"
                    label="Größe Durchmesser in cm"
                    outline
                    :customValidation="validated"
                    :isValid="valid"
                    :invalidFeedback="errors[0]"
                    validFeedback="sieht gut aus"
                  />
                </validation-provider>
                <validation-provider
                  name="Tiefe"
                  rules="max:10"
                  v-slot="{ errors, valid, validated }"
                  slim
                >
                  <mdb-input
                    v-model="form.Tiefe"
                    type="text"
                    label="Tiefe"
                    outline
                    :customValidation="validated"
                    :isValid="valid"
                    :invalidFeedback="errors[0]"
                    validFeedback="sieht gut aus"
                  />
                </validation-provider>
                <mdb-switch
                  v-model="form.Flaechig"
                  color="primary"
                  class="mb-3"
                  offLabel=""
                  onLabel="flächig"/>
                <mdb-switch
                  v-model="form.Trocken"
                  color="primary"
                  offLabel=""
                  onLabel="Trocken"/>
                <validation-provider
                  name="Nässend"
                  rules="required"
                  v-slot="{ errors, valid, validated }"
                  slim
                >
                  <mdb-select
                    outline
                    id="nässend"
                    v-model="oozingOptions"
                    label="Nässend"
                    name="Nässend"
                    placeholder="Nässend"
                    :customValidation="validated"
                    :isValid="valid"
                    :invalidFeedback="errors[0]"
                    validFeedback="sieht gut aus"
                  />
                </validation-provider>
                <validation-provider
                  name="Wundränder"
                  rules="required"
                  v-slot="{ errors, valid, validated }"
                  slim
                >
                  <mdb-select
                    outline
                    id="wundränder"
                    v-model="woundEdgesOptions"
                    label="Wundränder"
                    name="Wundränder"
                    placeholder="Wundränder auswählen"
                    :customValidation="validated"
                    :isValid="valid"
                    :invalidFeedback="errors[0]"
                    validFeedback="sieht gut aus"
                  />
                </validation-provider>
                <validation-provider
                  name="Geruch"
                  rules="required"
                  v-slot="{ errors, valid, validated }"
                  slim
                >
                  <mdb-select
                    outline
                    id="geruch"
                    v-model="smellOptions"
                    label="Geruch"
                    name="Geruch"
                    placeholder="Geruch auswählen"
                    :customValidation="validated"
                    :isValid="valid"
                    :invalidFeedback="errors[0]"
                    validFeedback="sieht gut aus"
                  />
                </validation-provider>
                <validation-provider
                  name="Pflegeanweisung"
                  rules="required"
                  v-slot="{ errors, valid, validated }"
                  slim
                >
                  <mdb-input
                    v-model="form.Anweisung"
                    type="textarea"
                    :rows="5"
                    label="Pflegeanweisung"
                    name="Pflegeanweisung"
                    :customValidation="validated"
                    :isValid="valid"
                    :invalidFeedback="errors[0]"
                    validFeedback="sieht gut aus"
                    outline
                  />
                </validation-provider>
              </mdb-modal-body>
            <mdb-modal-footer>
              <mdb-btn color="grey lighten-1" @click.native="close">Zurück</mdb-btn>
              <mdb-btn
                color="primary"
                :disabled="loading"
                type="submit"
              >
                <template v-if="!loading">
                  Erstellen <mdb-icon icon="save" />
                </template>
                <template v-else>
                  <span
                    class="spinner-grow spinner-grow-sm"
                    role="status"
                    aria-hidden="true"
                  />
                  Verladung
                </template>
              </mdb-btn>
            </mdb-modal-footer>
        </mdb-modal>
      </form>
    </validation-observer>
  </div>
</template>

<script>
  import {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
    mdbSelect,
    mdbDatePicker,
    mdbInput,
    mdbSwitch,
    mdbIcon
  } from 'mdbvue';
  import utils from '@/mixins/Utils'

  export default {
    name: 'WoundCourse',
    mixins: [utils()],

    components: {
      mdbModal,
      mdbModalHeader,
      mdbModalTitle,
      mdbModalBody,
      mdbModalFooter,
      mdbBtn,
      mdbSelect,
      mdbDatePicker,
      mdbInput,
      mdbSwitch,
      mdbIcon
    },

    props: {
      modalState: {
        type: Boolean,
        default: false,
      },
      woundDetails: {
        type: Object,
       default: () => {},
      },
    },

    data() {
      return {
        modal: false,
        loading: false,
        uhrzeit: new Date().getHours() + ":" + new Date().getMinutes(),
        datum: new Date().toISOString().slice(0,10),
        erhebung: new Date().toJSON().slice(0,10).split('-').reverse().join('-'),
        form: {
          Erhebung: '',
          Naessend: null,
          Raender: null,
          Geruch: null,
          Tiefe: '',
          Flaechig: false,
          Trocken: false,
          Durchmesser: '',
          Anweisung: '',
        },
        defaultForm: {
          Erhebung: '',
          Naessend: null,
          Raender: null,
          Geruch: null,
          Tiefe: '',
          Flaechig: false,
          Trocken: false,
          Durchmesser: '',
          Anweisung: '',
        },
      }
    },

    computed: {
      selectedOozingOptions() {
        let response = this.oozingOptions.find(option => {
          return option.selected === true
        });
        if (response) {
          return response.value
        }
        return ""
      },
      selectedWoundEdges() {
        let response = this.woundEdgesOptions.find(option => {
          return option.selected === true
        });
        if (response) {
          return response.value
        }
        return ""
      },
      selectedSmellOptions() {
        let response = this.smellOptions.find(option => {
          return option.selected === true
        });
        if (response) {
          return response.value
        }
        return ""
      }
    },

    watch: {
      modalState (v) {
        this.modal = v
      },
    },

    methods: {
      close () {
        this.$refs.form.reset()
        this.datum = new Date().toISOString().slice(0,10),
        this.erhebung = new Date().toJSON().slice(0,10).split('-').reverse().join('-'),
        this.uhrzeit = new Date().getHours() + ":" + new Date().getMinutes(),
        this.form = Object.assign({}, this.defaultForm)
        this.$emit('close')
      },

      save() {
        this.close()
        this.$emit('save')
      },

      getPickersValue (value) {
        if(value) {
          this.erhebung = value
        }
      },

      saveWoundCourse() {
        //set select data
        this.form.Naessend = this.selectedOozingOptions
        this.form.Raender = this.selectedWoundEdges
        this.form.Geruch = this.selectedSmellOptions


        this.form.Erhebung = this.formatDateY(this.erhebung)
        var userDate= new Date(this.datum + ' ' + this.uhrzeit)
        this.form.AenderungAm =  this.serverDateFormat(userDate)
        this.form.Erhebung =  this.form.Erhebung ? this.serverDateFormat(new Date(this.form.Erhebung+ ' ' + this.uhrzeit)) : ''
        this.form.AenderungVon = this.loginUser.username
        this.form.key = this.woundDetails.id

        this.loading = true
        this.$refs.form.validate().then(success => {
          if (!success) {
            this.loading = false
            return
          }

          this.$http.post('WundVerlauf', this.form)
            .then(res => {
              if(res.data) {
                this.$notify.success({message: 'Wunderhebung erstellen erfolgreich', position: 'top right', closeButton: false, timeOut: 5000})
                this.save()
              }else {
                this.$notify.error({message: 'Gescheitert Wunderhebung erstellen!!', position: 'top right', closeButton: false, timeOut: 5000})
              }
            })
            .finally(() => {
              this.loading = false
            })
        });
      }
    }
  }
</script>
